module.exports = __webpack_public_path__ + "img/vertical_6_3_5010.5140b0f4.png";